// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
}

.documentation-page {
  background: #f3f4f8;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding: 0.65rem clamp(0.65rem, 2vw, 1.4rem) 1.4rem;
}

.page-heading {
  background: #fff;
  border: 1px solid #d9e2ec;
  border-left: 4px solid #007bff;
  border-radius: 7px;
  margin: 0 0 1.2rem;
  padding: 0.9rem clamp(1rem, 3vw, 2rem);
  text-align: center;
}

.page-heading::before,
.page-heading::after {
  content: none !important;
  display: none !important;
}

.eyebrow {
  color: #0070a8;
  font-size: 0.7rem;
  font-weight: 700;
  margin: 0 0 0.15rem;
  text-transform: uppercase;
}

h1 {
  color: #173a5e;
  font-size: clamp(1.3rem, 2vw, 1.65rem);
  font-weight: 700;
  line-height: 1.15;
  margin: 0;
}

.page-introduction,
.section-heading p {
  color: #66798b;
}

.page-introduction {
  font-size: 0.82rem;
  margin: 0.25rem 0 0;
}

.documentation-content {
  margin: 0 auto;
  max-width: 1180px;
}

.resource-section + .resource-section {
  border-top: 1px solid #d4dce5;
  margin-top: 1.4rem;
  padding-top: 1.4rem;
}

.section-heading {
  margin-bottom: 0.7rem;
}

.section-heading h2 {
  color: #234968;
  font-size: 1rem;
  margin: 0;
}

.section-heading p {
  font-size: 0.75rem;
  margin: 0.15rem 0 0;
}

.resource-grid {
  display: grid;
  gap: 0.75rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.resource-card {
  align-items: center;
  background: #fff;
  border: 1px solid #d9e2ec;
  border-radius: 7px;
  color: #243b53;
  display: grid;
  gap: 0.8rem;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  min-height: 92px;
  padding: 0.8rem;
  text-decoration: none;
}

a.resource-card {
  box-shadow: 0 1px 2px rgba(31, 78, 120, 0.08);
  transition: border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
}

a.resource-card:hover,
a.resource-card:focus-visible {
  border-color: #4299c6;
  box-shadow: 0 5px 14px rgba(31, 78, 120, 0.15);
  color: #173a5e;
  outline: none;
  transform: translateY(-2px);
}

.resource-icon {
  align-items: center;
  background: #e4f2fb;
  border: 1px solid #b8dcef;
  border-radius: 6px;
  color: #176c96;
  display: flex;
  font-size: 1rem;
  height: 42px;
  justify-content: center;
  width: 42px;
}

.resource-details {
  display: grid;
  gap: 0.18rem;
  min-width: 0;
}

.resource-details strong {
  color: #173a5e;
  font-size: 0.88rem;
}

.resource-details > span {
  color: #66798b;
  font-size: 0.72rem;
  line-height: 1.35;
}

.open-icon {
  color: #007bba;
  font-size: 0.85rem;
}

.resource-card--pending {
  background: #f8f9fb;
  border-style: dashed;
}

.resource-card--pending .resource-icon {
  background: #edf0f3;
  border-color: #d4d9df;
  color: #7a8793;
}

.pending-label {
  background: #edf0f3;
  border-radius: 4px;
  color: #63717d;
  font-size: 0.65rem;
  font-weight: 700;
  padding: 0.25rem 0.45rem;
  white-space: nowrap;
}

@media (max-width: 900px) {
  .resource-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .documentation-page {
    padding-bottom: 1rem;
  }

  .page-heading {
    margin-bottom: 1rem;
  }

  .resource-grid {
    grid-template-columns: 1fr;
  }

  .resource-card {
    min-height: 82px;
  }
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/lab-documentation/lab-documentation.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,WAAW;EACX,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,6CAA6C;EAC7C,gFAAgF;AAClF;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;EAC9C,cAAc;EACd,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[":host {\n  display: flex;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.documentation-page {\n  background: #f3f4f8;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto;\n  padding: 0.65rem clamp(0.65rem, 2vw, 1.4rem) 1.4rem;\n}\n\n.page-heading {\n  background: #fff;\n  border: 1px solid #d9e2ec;\n  border-left: 4px solid #007bff;\n  border-radius: 7px;\n  margin: 0 0 1.2rem;\n  padding: 0.9rem clamp(1rem, 3vw, 2rem);\n  text-align: center;\n}\n\n.page-heading::before,\n.page-heading::after {\n  content: none !important;\n  display: none !important;\n}\n\n.eyebrow {\n  color: #0070a8;\n  font-size: 0.7rem;\n  font-weight: 700;\n  margin: 0 0 0.15rem;\n  text-transform: uppercase;\n}\n\nh1 {\n  color: #173a5e;\n  font-size: clamp(1.3rem, 2vw, 1.65rem);\n  font-weight: 700;\n  line-height: 1.15;\n  margin: 0;\n}\n\n.page-introduction,\n.section-heading p {\n  color: #66798b;\n}\n\n.page-introduction {\n  font-size: 0.82rem;\n  margin: 0.25rem 0 0;\n}\n\n.documentation-content {\n  margin: 0 auto;\n  max-width: 1180px;\n}\n\n.resource-section + .resource-section {\n  border-top: 1px solid #d4dce5;\n  margin-top: 1.4rem;\n  padding-top: 1.4rem;\n}\n\n.section-heading {\n  margin-bottom: 0.7rem;\n}\n\n.section-heading h2 {\n  color: #234968;\n  font-size: 1rem;\n  margin: 0;\n}\n\n.section-heading p {\n  font-size: 0.75rem;\n  margin: 0.15rem 0 0;\n}\n\n.resource-grid {\n  display: grid;\n  gap: 0.75rem;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.resource-card {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #d9e2ec;\n  border-radius: 7px;\n  color: #243b53;\n  display: grid;\n  gap: 0.8rem;\n  grid-template-columns: 42px minmax(0, 1fr) auto;\n  min-height: 92px;\n  padding: 0.8rem;\n  text-decoration: none;\n}\n\na.resource-card {\n  box-shadow: 0 1px 2px rgba(31, 78, 120, 0.08);\n  transition: border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;\n}\n\na.resource-card:hover,\na.resource-card:focus-visible {\n  border-color: #4299c6;\n  box-shadow: 0 5px 14px rgba(31, 78, 120, 0.15);\n  color: #173a5e;\n  outline: none;\n  transform: translateY(-2px);\n}\n\n.resource-icon {\n  align-items: center;\n  background: #e4f2fb;\n  border: 1px solid #b8dcef;\n  border-radius: 6px;\n  color: #176c96;\n  display: flex;\n  font-size: 1rem;\n  height: 42px;\n  justify-content: center;\n  width: 42px;\n}\n\n.resource-details {\n  display: grid;\n  gap: 0.18rem;\n  min-width: 0;\n}\n\n.resource-details strong {\n  color: #173a5e;\n  font-size: 0.88rem;\n}\n\n.resource-details > span {\n  color: #66798b;\n  font-size: 0.72rem;\n  line-height: 1.35;\n}\n\n.open-icon {\n  color: #007bba;\n  font-size: 0.85rem;\n}\n\n.resource-card--pending {\n  background: #f8f9fb;\n  border-style: dashed;\n}\n\n.resource-card--pending .resource-icon {\n  background: #edf0f3;\n  border-color: #d4d9df;\n  color: #7a8793;\n}\n\n.pending-label {\n  background: #edf0f3;\n  border-radius: 4px;\n  color: #63717d;\n  font-size: 0.65rem;\n  font-weight: 700;\n  padding: 0.25rem 0.45rem;\n  white-space: nowrap;\n}\n\n@media (max-width: 900px) {\n  .resource-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 600px) {\n  .documentation-page {\n    padding-bottom: 1rem;\n  }\n\n  .page-heading {\n    margin-bottom: 1rem;\n  }\n\n  .resource-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .resource-card {\n    min-height: 82px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
